/**
 * Context object is injected to schema before render,
 * and is removed when form is submitted,
 * its only purpous is to allow using additional data in schema rule conditions.
 * For eg. you want to remove certain fields from display side of form, 
 * or there are rules for certain permit status.
 */

import { IFormSchema } from "./IFormSchema";

export interface ISchemaContext {
    roles: string[];
    // canViewNames: boolean;
    mode: "display" | "form",
    //  pdf?: boolean
}

export const contextSchema: IFormSchema["schema"] = {
    "type": "object",
    "properties": {
        "roles": {
            "type": "array",
            "items": {
                "type": "string"
            }
        },
        "canViewNames": {
            "type": "boolean"
        },
        "mode": {
            "type": "string",
            "enum": ["display", "form"]
        }
    }
};
